import { styled } from '@mui/material/styles';

interface StyledAgentImageProps {
  width?: string;
}

const StyledAgentImage = styled('img')<StyledAgentImageProps>`
  height: auto;
  object-fit: cover;
  border-radius: 22px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${({ width }) => width || '100%'};
  }
`;

export default StyledAgentImage;
